import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { contactData, navLinks, contadoraData } from '../../data/mock';
import '../../styles/landing.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand */}
          <div className="footer-brand">
            <div className="logo-text" style={{ fontSize: '1.75rem' }}>
              CPC <span>Eliana Espilco</span>
            </div>
            <p>
              Servicios contables y tributarios profesionales para emprendedores y empresas en Perú.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4>Navegación</h4>
            <ul className="footer-links">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <button onClick={() => scrollToSection(link.href)}>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h4>Servicios</h4>
            <ul className="footer-links">
              <li><span style={{ color: '#9CA3AF' }}>Contabilidad</span></li>
              <li><span style={{ color: '#9CA3AF' }}>Tributación</span></li>
              <li><span style={{ color: '#9CA3AF' }}>Asesoría SUNAT</span></li>
              <li><span style={{ color: '#9CA3AF' }}>Declaraciones</span></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4>Contacto</h4>
            <div className="footer-contact-item">
              <Phone size={16} />
              <span>{contactData.whatsapp}</span>
            </div>
            <div className="footer-contact-item">
              <Mail size={16} />
              <span>{contactData.email}</span>
            </div>
            <div className="footer-contact-item">
              <MapPin size={16} />
              <span>Atención Nacional - Perú</span>
            </div>
          </div>
        </div>
        
        <div className="footer-divider">
          <p>© {currentYear} {contadoraData.nombre}. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
